import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation, } from 'react-router-dom';
import ListSearchSection from '../../utils/commonComponent/Custom/ListSearchSection';
import { fetchQuery } from '../../utils/commonComponent/fetched';
import { certQuery } from './certQuery';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import { mulipleApproveCertificates } from './mulipleApproveCertificates';
import { getPermissions } from '../rbac/hasAccess';
import { Tooltip } from '@mui/material';
import MultipleCertificateDownload from './multipleCertificateDownload';
import { handleWithdrawApproval } from './handleWithdrawApproval';

const headers = ["id", "customerName", "materialName", "testName", "jobNumber", "labReferenceNo", "testNumber", "ULRNo", "ReportNo",];

const fields = [
  { value: "inward.customerName", label: "Customer Name" },
  { value: "jobRegister.jobNumber", label: "Job Number" },
  // { value: "materialScope.MaterialName", label: "Material Name" },
  // { value: "materialTestings.testName", label: "Test Name" },
  // { value: "observationSheet.testNumber", label: "Test No." },
  { value: "certificate.ulrNumber", label: "ULR No." },
  { value: "certificate.reportNumber", label: "Report No." },
];

// Mapping between headers and SQL result fields
const fieldMap = {
  jobNumbers: "jobRegister_jobNumber",
  labReferenceNos: "inward_labReferenceNo",
  customerName: "inward_customerName",
  materialName: "materialScope_MaterialName",
  testName: "materialTestings_testNames",
  testNumbers: "observationSheet_testNumber",
  ULRNo: "certificate_ulrNumber",
  ReportNo: "certificate_reportNumber",
};

const getBackgroundColor = (row) => {
  if (row.certificate_rejectedBy) return '#FF3F33'; // Rejected by
  if (row.certificate_authorizedBy) return '#A0A0F7'; // Authorized by
  if (row.certificate_reviewedBy) return '#F392F3'; // Reviewed by
  if (row.certificate_preparedBy) return '#6CE796'; // Prepared By
  if (row?.observationSheet_totalReading && row?.observationSheet_totalReading != 0) return '#22c9b0'; // Tested By
  return ''; // Default color
};

const getTooltipText = (row) => {
  if (row.certificate_rejectedBy) return row.rejectedBy_userName ? `Rejected By ${row.rejectedBy_userName}` : 'Rejected By';
  if (row.certificate_authorizedBy) return row.authorizedBy_userName ? `Authorized By ${row.authorizedBy_userName}` : 'Authorized By';
  if (row.certificate_reviewedBy) return row.reviewedBy_userName ? `Reviewed By ${row.reviewedBy_userName}` : 'Reviewed By';
  if (row.observationSheet_testedBy) return row.testedBy_userName ? `Tested By ${row.testedBy_userName}` : 'Tested By';
  return ''; // No tooltip text
};

const CertificateList = (props) => {
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const location = useLocation();
  const [filterFromDashboard, setFilterFromDashboard] = useState(location.state?.filter || null);

  const [searchBy, setSearchBy] = useState(sessionStorage.getItem("searchBy") || "jobRegister.jobNumber");
  const [searchKey, setSearchKey] = useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = useState(sessionStorage.getItem("searched") === "true" || false);
  const [certificateList, setCertificateList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedLabRef, setSelectedLabRef] = useState(null);
  const [showMultipleDownload, setShowMultipleDownload] = useState(false);

  // Pagination statese
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));  

  const _userType = Number(localStorage.getItem("type"));
  const _userId = Number(localStorage.getItem("id"));
  const _groupId = localStorage.getItem("groupId") || "";
  const _clientId = localStorage.getItem("clientId") || "";

  const getQuery = (count = false) => {
    let whereConditions = "WHERE certificate.status = 1";

    if (searchBy && searchKey) {
      whereConditions += ` AND LOWER(${searchBy}) LIKE LOWER('%${searchKey}%')`;
    }

    // If user type is 4, only show records assigned
    if (_userType == 4 && filterFromDashboard) {
      if (filterFromDashboard === "Assigned Test") {
        whereConditions += ` AND observationSheet.jobAssignedUser = ${_userId} AND observationSheet.status = 1`;
      } else if (filterFromDashboard === "Pending Test") {
        whereConditions += ` AND observationSheet.jobAssignedUser = ${_userId} AND observationSheet.status = 1 AND (observationSheet.totalReadings IS NULL OR observationSheet.totalReadings = 0)`;
      } else if (filterFromDashboard === "Completed Test") {
        whereConditions += ` AND observationSheet.jobAssignedUser = ${_userId} AND observationSheet.status = 1 AND observationSheet.totalReadings > 0`;
      }
    }
    // If user type is 4, only show records assigned is engineer
    if (_userType == 4) {
      whereConditions += ` AND (observationSheet.jobAssignedUser = ${_userId} OR inward.createdBy = ${_userId})`;
    }
    // userType 13 is client
    if (_userType == 13 && _clientId && _clientId !== "null") {
        whereConditions += ` AND jobRegister.clientId = ${Number(_clientId)}`;
      }

    // If groupId available
    if (_groupId && _groupId !== "null") {
      const groupIds = _groupId.split(',');
        const groupConditions = groupIds.map(id => `FIND_IN_SET(${id.trim()}, inwardTests.groupId)`).join(' OR ');
        whereConditions += ` AND (${groupConditions} OR inwardTests.id IS NULL OR inwardTests.groupId IS NULL OR inwardTests.groupId = '')`;
    }

    if (selectedLabRef) {
      whereConditions += ` AND inward.labReferenceNo = '${selectedLabRef}'`;
    }

    if (count) {
      return `SELECT COUNT(*) AS no_of_rows FROM (${certQuery} ${whereConditions} GROUP BY certificate.id) AS count_table;`;
    }

    // Add pagination to query
    const offset = currentPage * rowsPerPage;

    return `${certQuery} ${whereConditions} GROUP BY certificate.id ORDER BY certificate.id DESC LIMIT ${rowsPerPage} OFFSET ${offset};`;
  };

  const fetchData = async () => {
    try {
      // Fetch count
      const countQuery = getQuery(true);
      const countResult = await fetchQuery(countQuery);
      setTotalRecords(countResult[0]?.no_of_rows || 0);

      // Fetch paginated data
      const query = getQuery();
      const result = await fetchQuery(query);

      const mappedData = result.map((row) => {
        // Build display data
        const displayFields = {};
        headers.forEach((header) => {
          displayFields[header] = row[fieldMap[header]] ?? "-";
        });

        // Merge with full row data, preserving everything
        return {
          ...displayFields, // 👈 only the display fields
          ...row, // 👈 full raw row data
        };
      });

      setCertificateList(mappedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
    fetchData();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("jobRegister.jobNumber");
    setSearchKey("");
    setCurrentPage(0);
    setFilterFromDashboard(null);
    // Clear all cert list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  useEffect(() => {
    if (filterFromDashboard) {
      fetchData();
      setSearched(true);
    }
  }, [filterFromDashboard]);

  useEffect(() => {
    if (selectedLabRef) {
      fetchData();
    }
  }, [selectedLabRef]);


  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
  };

  // ===== handleSelectAll =====
  const handleSelectAll = () => {
    // Filter rows that are eligible for selection
    const selectableRows = certificateList.filter(row => row.observationSheet_testedBy);
    const selectableIds = selectableRows.map(row => row.id);

    if (selectedIds.length === selectableIds.length) {
      // Unselect all
      setSelectedIds([]);
    } else {
      // Select only eligible rows
      setSelectedIds(selectableIds);
    }
  };

  const isAllSelected = selectedIds.length === certificateList.length && certificateList.length > 0;

  return (
    <>
      <ListSearchSection
        title="Search Certificate"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
        extraButtonLable="Multiple Download"
        extraButton={true}
        onJobAssignClick={() => setShowMultipleDownload(!showMultipleDownload)}

      />
      <div className='flex items-center gap-5 my-2'>
        <div>
          {selectedIds.length > 0 && props.rolesInfo?.currentRole?.id == 4 && (
            <div className="flex justify-start my-3">
              <button
                onClick={() => mulipleApproveCertificates("authorized", selectedIds)}
                className="bg-[#7B7BCF] text-white px-4 py-2 rounded-md hover:bg-violet-700">
                Authorized
              </button>
            </div>
          )}
          {selectedIds.length > 0 && props.rolesInfo?.currentRole?.id == 3 && (
            <div className="flex justify-start my-3">
              <button
                onClick={() => mulipleApproveCertificates("review", selectedIds)}
                className="bg-[#E672E6] text-white px-4 py-2 rounded-md hover:bg-[#E641E6]"
              >
                Review
              </button>
            </div>
          )}
          {selectedIds.length > 0 && props.rolesInfo?.currentRole?.id == 2 && (
            <div className="flex justify-start my-3">
              <button
                onClick={() => mulipleApproveCertificates("prepared", selectedIds)}
                className="bg-[#6CE796] text-white px-4 py-2 rounded-md hover:bg-[#6CE796]"
              >
                Prepared
              </button>
            </div>
          )}
        </div>
        <div>
          {/* // withdraw approval */}
          {selectedIds.length > 0 && (
            <div className="flex justify-start my-3">
              <button
                onClick={() => handleWithdrawApproval(selectedIds)}
                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
              >
                Withdraw Approval
              </button>
            </div>
          )}
        </div>
      </div>

      {showMultipleDownload && (
        <MultipleCertificateDownload
          _userType={_userType}
          showJobAssign={(labRef) => { setSelectedLabRef(labRef ? labRef.label : null) }}
          onJobAssignClick={() => {
            setShowMultipleDownload(!showMultipleDownload);
            setSelectedLabRef(null);
            fetchData();
            setTimeout(() => {
              fetchData(); // refresh to show full unfiltered list
            }, 100);
          }}
        />
      )}

      <div className="w-full border rounded-md shadow">
        {/* Table Container */}
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                {_userType != 13 &&(<th className="px-2 py-3 text-center">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                </th>)}
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Sr. No.</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Customer Name</th>
                {/* <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Material Name</th> */}
                {/* <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Test Name</th> */}
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Job Number</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Lab Ref No</th>
                {/* <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Test No</th> */}
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">ULR No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Report No</th>
                {(permissions.view || permissions.allAccess) && (
                  <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Actions</th>
                )}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {certificateList.map((row, index) => {
                return (
                  <tr key={row.id} className="hover:bg-gray-50">
                    {_userType != 13 &&(<td className="px-2 py-2 text-center">
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(row.id)}
                        onChange={() => handleSelectRow(row.id)}
                        disabled={!row.observationSheet_testedBy}
                      />
                    </td>)}
                    <td className="px-4 py-2 text-center">{currentPage * rowsPerPage + index + 1}</td>
                    <td className="px-4 py-2 text-center truncate-text">{row.inward_customerName || '-'}</td>
                    {/* <Tooltip title={getTooltipText(row)} placement="top">
                      <td className="px-4 py-2 text-center" style={{ backgroundColor: getBackgroundColor(row) }}>
                        <Link to={`/viewCertificate/${row.id}`} className="hover:text-blue-600">
                          {row.materialScope_MaterialName || '-'}
                        </Link>
                      </td>
                    </Tooltip> */}
                    {/* <Tooltip title={getTooltipText(row)} placement="top">
                      <td className="px-4 py-2 text-center truncate-text" style={{ backgroundColor: getBackgroundColor(row) }}>
                        <Link to={`/viewCertificate/${row.id}`} className="hover:text-blue-600">
                          {row.materialTestings_testNames || '-'}
                        </Link>
                      </td>
                    </Tooltip> */}
                    <td className="px-4 py-2 text-center" style={{ backgroundColor: getBackgroundColor(row) }}>
                     <Link to={`/viewCertificate/${row.id}`} className="hover:text-blue-600">
                      {row.jobRegister_jobNumber || '-'}
                     </Link>
                    </td>
                    <td className="px-4 py-2 text-center">{row.inward_labReferenceNo || '-'}</td>
                    {/* <Tooltip title={getTooltipText(row)} placement="top">
                      <td className="px-4 py-2 text-center" style={{ backgroundColor: getBackgroundColor(row) }}>
                        <Link to={`/viewCertificate/${row.id}`} className="hover:text-blue-600">
                          {row.observationSheet_testNumbers || '-'}
                        </Link>
                      </td>
                    </Tooltip> */}
                    <td className="px-4 py-2 text-center">{row.certificate_ulrNumber || '-'}</td>
                    <td className="px-4 py-2 text-center" style={{ backgroundColor: getBackgroundColor(row) }}>
                      <Link to={`/viewCertificate/${row.id}`} className="hover:text-blue-600">
                        {row.certificate_reportNumber || '-'}
                      </Link>
                    </td>
                    <td className="px-4 py-2 text-center">
                      {
                        (permissions.view || permissions.allAccess) && (
                          <button
                            onClick={() => navigate(`/viewCertificate/${row?.id}`)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <VisibilityIcon fontSize="small" />
                          </button>
                        )}
                    </td>
                  </tr>
                );
              })}

              {certificateList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 2}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between gap-2 px-2 py-2 bg-blue-50 text-xs sm:text-sm border-t overflow-x-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <span>Rows Per Page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-1 py-0.5 text-xs sm:text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-gray-600 hidden sm:inline">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRecords
                )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default CertificateList;